module.exports = __webpack_public_path__ + "img/P7-color.a8194462.svg";